import { Trans } from "react-i18next";

import type { NotificationContentProps } from "../types";

export default function PollClosed({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.pollClosed"
      values={{ poll: context?.pollName || "Deleted" }}
    />
  );
}
